module.exports = __webpack_public_path__ + "img/symbol_3.3b3f334f.png";